import React from "react";
// import CrossIcon from "../../../../.."
import CrossIcon from "../../../../../assets/Icons/Universal/CrossHoloIcon.svg";
import FormInput from "../../../../Universal/FormInput.component";

const InputRowItem = ({ index, remove, touched, errors }) => {
  return (
    <div className="w-full flex-row align-left justify-start g-05">
      <span className="t-12 poppins color-textColor">{index + 1}.</span>
      <div className="w-full flex-row align-center justify-start g-05">
        <FormInput
          type="text"
          name={`transactions[${index}].name`}
          label="Name"
          placeholder="Enter the fee type"
          containerClass={"w-half"}
          touched={touched}
          errors={errors}
        />
        <FormInput
          type="number"
          name={`transactions[${index}].amount`}
          label="Amount (INR)"
          placeholder="Enter an amount"
          containerClass={"w-half"}
          touched={touched}
          errors={errors}
        />
        <button
          type="button"
          className="transparentBtn w-fit h-fit"
          style={{ marginTop: "1.5rem" }}
          onClick={() => remove(index)}
        >
          <img src={CrossIcon} alt="Remove" />
        </button>
      </div>
    </div>
  );
};

export default InputRowItem;
